import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ENV } from '../environments/environment';
import { ENVIRONMENTS } from '../environments/environments';
import { AppConfig } from './app.config';
import { AppModule } from './app.module';

if (ENV.name !== ENVIRONMENTS.DEV) {
    enableProdMode();
    (window as any).oldConsoleLog = console.log;
    (window as any).console.log = () => {
        // ignore
    };
    (window as any).oldConsoleDebug = console.debug;
    (window as any).console.debug = () => {
        // ignore
    };
}

platformBrowserDynamic().bootstrapModule(AppModule);

(window as any).AppControl = {
    setOfflineMode: mode => {
        AppConfig.offlineMode = mode;
    },
    getOfflineMode: () => {
        return AppConfig.offlineMode;
    }
};



// WEBPACK FOOTER //
// ./src/app/main.ts